import { render, staticRenderFns } from "./Suche.vue?vue&type=template&id=31b111ff&"
import script from "./Suche.vue?vue&type=script&lang=js&"
export * from "./Suche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports